module.exports = __webpack_public_path__ + "static/media/imageMiddle.348a5a14.png";